import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerReactAppFactory} from '@github-ui/react-core/register-app'

import {App} from './App'
import {CustomPropertiesSchemaPage} from './routes/CustomPropertiesSchemaPage'
import {CustomPropertyDetailsPage} from './routes/CustomPropertyDetailsPage'
import {RepoCustomPropertiesPage} from './routes/RepoCustomPropertiesPage'
import {RepoSettingsCustomPropertiesPage} from './routes/RepoSettingsCustomPropertiesPage'

export const propertiesRoute = jsonRoute({
  path: '/:org/:repo/settings/custom-properties',
  Component: RepoSettingsCustomPropertiesPage,
})

export const definitionsRoute = jsonRoute({
  path: '/organizations/:org/settings/custom-properties',
  Component: CustomPropertiesSchemaPage,
})

export const editDefinitionRoute = jsonRoute({
  path: '/organizations/:org/settings/custom-property/:propertyName',
  Component: CustomPropertyDetailsPage,
})

const createDefinitionRoute = jsonRoute({
  path: '/organizations/:org/settings/custom-property',
  Component: CustomPropertyDetailsPage,
})

export const repoCustomPropertiesRoute = jsonRoute({
  path: '/:org/:repo/custom-properties',
  Component: RepoCustomPropertiesPage,
})

registerReactAppFactory('custom-properties', () => ({
  App,
  routes: [repoCustomPropertiesRoute, propertiesRoute, createDefinitionRoute, editDefinitionRoute, definitionsRoute],
}))
